export const saudiRegions = [
  {
    id: 1,
    name: " الرياض",
    cities: [
      "الرياض",
      "الدرعية",
      "الخرج",
      "الدوادمي",
      "المجمعة",
      "القويعية",
      "وادي الدواسر",
      "الأفلاج",
      "شقراء",
      "حوطة بني تميم",
      "عفيف",
      "السيح",
      "ثادق",
      "الحريق",
      "المزاحمية",
      "رماح",
      "ثرمداء",
      "حريملاء",
      "الغاط",
      "مرات",
      "السليل",
      "ضرما",
      "الزلفي",
      "ساجر",
      "المعظم",
      "الحوطة",
      "العيينة",
      "العمارية",
      "العارض",
      "الصلبية",
      "العزيزية",
      "البديعة",
      "النسيم",
      "الملز",
      "الغرابي",
      "العريجاء",
      "المربع",
      "الوشام",
      "قصر الحكم",
      "البجادية",
      "المليبد",
      "الشقة",
      "مزعلة",
      "أشيقر",
      "الدلم",
      "الهدار",
      "الروضة",
      "الفيصلية",
    ],
  },
  {
    id: 2,
    name: " مكة المكرمة",
    cities: [
      "مكة المكرمة",
      "جدة",
      "الطائف",
      "القنفذة",
      "الليث",
      "رابغ",
      "خليص",
      "الخرمة",
      "رنية",
      "تربة",
      "الكامل",
      "المويه",
      "ميسان",
      "أضم",
      "العرضيات",
      "بحرة",
      "عسفان",
      "الشقيق",
      "الجموم",
      "خليص",
      "ثول",
      "ذات عرق",
      "النوارية",
      "الحوية",
      "الخوبة",
      "المضيلع",
      "الصدر",
      "الهدا",
      "الشفا",
      "وادي فاطمة",
      "حداء",
      "الكردم",
      "السعدية",
      "العقيق",
      "بني مالك",
      "بني سعد",
    ],
  },
  {
    id: 3,
    name: " المدينة المنورة",
    cities: [
      "المدينة المنورة",
      "ينبع",
      "العلا",
      "المهد",
      "بدر",
      "خيبر",
      "الحناكية",
      "العيص",
      "وادي الفرع",
      "المندسة",
      "الصويدرة",
      "الحميمة",
      "الابيار",
      "السيح",
      "الصلصلة",
      "الثمد",
      "المويه الجديدة",
      "الفريش",
      "ذروان",
      "الرانوناء",
      "المجارى",
      "ابو ضباع",
      "النخيل",
      "العالية",
      "البدايع",
    ],
  },
  {
    id: 4,
    name: " القصيم",
    cities: [
      "بريدة",
      "عنيزة",
      "الرس",
      "المذنب",
      "البكيرية",
      "البدائع",
      "الأسياح",
      "النبهانية",
      "عيون الجواء",
      "رياض الخبراء",
      "الشماسية",
      "عقلة الصقور",
      "الخفجي",
      "الخبراء",
      "المليداء",
      "القوارة",
      "الضلفة",
      "المذنب",
      "المهينية",
      "الضبيعة",
      "القرعاء",
      "الجناح",
      "الشبيطة",
      "القرين",
      "العوشزية",
      "المحفر",
      "الطرفية",
      "الطرفية الغربية",
    ],
  },
  {
    id: 5,
    name: " الشرقية",
    cities: [
      "الدمام",
      "الخبر",
      "الظهران",
      "القطيف",
      "الأحساء",
      "بقيق",
      "حفر الباطن",
      "الجبيل",
      "النعيرية",
      "قرية العليا",
      "رأس تنورة",
      "الخفجي",
      "عدة مدن",
      "العديد",
      "المركز",
      "القرين",
      "العيون",
      "التويثير",
      "الجشة",
      "الخويلدية",
      "الجبيل الصناعية",
      "الظهران الصناعية",
      "سلوى",
      "الملاحة",
      "دارين",
      "عنك",
      "سيهات",
      "تاروت",
      "الجبيل التحلية",
      "الخبر الشمالية",
      "الخبر الجنوبية",
      "الدمام النخيل",
      "الدمام المركز",
    ],
  },
  {
    id: 6,
    name: " عسير",
    cities: [
      "أبها",
      "خميس مشيط",
      "بيشة",
      "النماص",
      "محايل عسير",
      "ظهران الجنوب",
      "تثليث",
      "سراة عبيدة",
      "رجال ألمع",
      "بلقرن",
      "أحد رفيدة",
      "المجاردة",
      "البرك",
      "تنومة",
      "طبب",
      "الحريضة",
      "الطلحة",
      "العرين",
      "الرياض",
      "خاط",
      "القرن",
      "الدرب",
      "الحرجة",
      "السنينة",
      "الجرادية",
      "الحصان",
      "الجوة",
      "الخضراء",
      "السلامة",
      "السودة",
    ],
  },
  {
    id: 7,
    name: " تبوك",
    cities: [
      "تبوك",
      "الوجه",
      "ضباء",
      "تيماء",
      "أملج",
      "حقل",
      "البدع",
      "المويلح",
      "الشجوى",
      "الزيتة",
      "الحوي",
      "العلقان",
      "الفحيلة",
      "اللصافة",
      "بئر بن هرماس",
      "الكتيب",
      "الرديفة",
      "الخريبة",
      "صدر",
      "عنتر",
      "الذنيب",
      "وادي أبو خشبة",
      "المغيصي",
    ],
  },
  {
    id: 8,
    name: " حائل",
    cities: [
      "حائل",
      "بقعاء",
      "الغزالة",
      "الشنان",
      "موقق",
      "سميرة",
      "الحائط",
      "الشيخان",
      "الشملي",
      "الحليفة",
      "السليمي",
      "الشعيبة",
      "الروضة",
      "الفياض",
      "قفار",
      "المستجدة",
      "البدع",
      "العباس",
      "الرصف",
      "الطويرف",
      "الصالحية",
      "المليح",
      "القعير",
      "الوجاج",
      "المعيقلات",
    ],
  },
  {
    id: 9,
    name: " الحدود الشمالية",
    cities: [
      "عرعر",
      "طريف",
      "رفحاء",
      "العويقيلة",
      "المركز",
      "الشعبة",
      "لوقة",
      "أم رضمة",
      "العبيد",
      "الدويد",
      "جديدة عرعر",
      "الكاسب",
      "الطويلة",
      "الحمادة",
      "المركوز",
      "نعيجان",
      "سماح الجديدة",
      "القرعاء",
      "ابن طوالة",
      "ابن شريم",
    ],
  },
  {
    id: 10,
    name: " جازان",
    cities: [
      "جازان",
      "صبيا",
      "أبو عريش",
      "صامطة",
      "بيش",
      "الدرب",
      "الحرث",
      "ضمد",
      "الريث",
      "فرسان",
      "الدائر",
      "العارضة",
      "أحد المسارحة",
      "العيدابي",
      "فيق",
      "الطوال",
      "الحصامة",
      "الخوبة",
      "المرابيع",
      "الموسم",
      "القحم",
      "البديع والقرفي",
      "شرج العوير",
      "المضايا",
      "العطيف",
      "الخمس",
      "المباركة",
      "الركنة",
      "المفتاحة",
      "السبخة",
    ],
  },
  {
    id: 11,
    name: " نجران",
    cities: [
      "نجران",
      "شرورة",
      "حبونا",
      "بدر الجنوب",
      "يدمة",
      "ثار",
      "خباش",
      "الخرخير",
      "آل سودة",
      "المجمع",
      "الشنية",
      "الحصينية",
      "الوديعة",
      "البراق",
      "الفهيد",
      "آل غيمان",
      "آل الشريفي",
      "آل قزعة",
      "الخالدية",
      "المساعدة",
      "السواد",
      "آل مهدي",
      "آل عاصم",
    ],
  },
  {
    id: 12,
    name: " الباحة",
    cities: [
      "الباحة",
      "بلجرشي",
      "المندق",
      "المخواة",
      "قلوة",
      "العقيق",
      "القرى",
      "غامد الزناد",
      "الحجرة",
      "بنى حسن",
      "المخواة",
      "الظفير",
      "الصغو",
      "المروة",
      "بني ظبيان",
      "الخلفة",
      "الصدر",
      "الخضراء",
      "الغراء",
      "الرهوة",
      "بني سار",
      "بني كبير",
      "آل يعلى",
      "آل عطيف",
      "آل جبلي",
      "الجعيمة",
      "الدحيم",
    ],
  },
  {
    id: 13,
    name: " الجوف",
    cities: [
      "سكاكا",
      "القريات",
      "دومة الجندل",
      "طبرجل",
      "صوير",
      "النبك أبو قصر",
      "الحديثة",
      "زلال",
      "قارا",
      "العيساوية",
      "الشويحطية",
      "الناصفة",
      "المرير",
      "ام نخيلة",
      "الطوير",
      "المرمة",
      "اللقايط",
      "ابو عجرم",
      "النبك",
      "الفياض",
      "الخناصرة",
      "المليح",
      "المسلسل",
      "الطورة",
      "الصفا",
    ],
  },
];